export default __webpack_public_path__ + "static/media/github.56df1390.svg";